<div class="px-4 sm:px-6 lg:px-8 py-4 lg:py-8 flex flex-col gap-4 items-start">
  <button (click)="navigateBack.emit()" appTailwindButton color="white" class="inline-flex gap-2">
    <app-ng-icon name="heroArrowLongDown" class="rotate-90"></app-ng-icon>
    <span>Zurück</span>
  </button>

  <div
    class="flex-1 w-full rounded-md border border-edge dark:border-zinc-500 relative overflow-hidden bg-surface shadow sm:rounded-lg"
    [class.!border-blue-600]="timer.state === 'active'"
    [class.!shadow-blue-600]="timer.state === 'active'"
  >
    <div class="border-b border-edge bg-surface px-4 py-5 sm:px-6">
      <div class="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
        <div class="ml-4 mt-2">
          <h3 class="text-base font-semibold text-fg-primary flex gap-4 items-center">
            <div class="text-lg font-semibold text-primary flex-shrink-0 text-right tabular-nums">
              {{
                timer.state === 'active'
                  ? (timer.startTime | secondsPassed | formatSeconds)
                  : (workForm.controls.workMinutes.value ?? 0 | formatWork)
              }}
            </div>
            <div>
              <div>
                {{
                  workForm.controls.project.value ? workForm.controls.project.value.displayName : ''
                }}
              </div>
              <div>
                {{
                  workForm.controls.position.value
                    ? workForm.controls.position.value.displayName
                    : ''
                }}
              </div>
            </div>
          </h3>
        </div>
        <div class="ml-4 mt-2 shrink-0 flex gap-4">
          @if (timer.state === 'inactive') {
            <app-dropdown-minimal-menu>
              <app-dropdown-button
                ><app-ng-icon name="heroTrash"></app-ng-icon
              ></app-dropdown-button>
              <app-dropdown-item (menuClick)="delete.emit()"> Löschen </app-dropdown-item>
            </app-dropdown-minimal-menu>
          }

          @if (timer.state === 'active') {
            <button type="button" appTailwindButton (click)="stop.emit()">
              <app-ng-icon class="text-2xl" name="heroPause"></app-ng-icon>
            </button>
          } @else {
            @if (timer.isToday) {
              <button type="button" appTailwindButton (click)="start.emit()">
                <app-ng-icon class="text-2xl" name="heroPlay"></app-ng-icon>
              </button>
            }
          }
        </div>
      </div>
    </div>

    @if (workForm) {
      <form autocomplete="off" novalidate>
        <div class="space-y-6 divide-y divide-separator pb-4">
          <div class="pt-6 pb-6 px-4 sm:px-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <app-dropdown
              label="Projekt"
              [formControl]="workForm.controls.project"
              [options]="projectSummaries"
            ></app-dropdown>
            <app-dropdown
              label="Position"
              [formControl]="workForm.controls.position"
              [options]="positionSummaries"
            ></app-dropdown>
          </div>
          <div class="space-y-4 pt-6 pb-5 px-4 sm:px-6">
            <app-text-input
              label="Beschreibung"
              [formControl]="workForm.controls.description"
              variant="textarea"
            ></app-text-input>
            <app-work-time-input
              label="Arbeitszeit"
              [formControl]="workForm.controls.workMinutes"
            ></app-work-time-input>
          </div>
          @if (timer.timeEntries) {
            <div class="pt-6 px-4 sm:px-6 space-y-3">
              <label class="block text-sm/6 font-medium text-fg-primary">Zeiteinträge</label>
              @for (timeEntry of timer.timeEntries; track timeEntry.id) {
                <div class="grid grid-cols-4 gap-2 text-fg-secondary">
                  <div class="mt-2 tabular-nums">{{ timeEntry.startTime | date: 'HH:mm' }}</div>
                  <div class="mt-2 tabular-nums">{{ timeEntry.endTime | date: 'HH:mm' }}</div>
                  <div class="mt-2 tabular-nums">{{ timeEntry.totalMinutes | formatWork }}h</div>
                  @if (
                    timer.state === 'inactive' &&
                    timer.workItemState === 'embedded' &&
                    timeEntry.isSameDay
                  ) {
                    @if (editingTimeEntryId === null) {
                      <button
                        type="button"
                        appTailwindButton
                        color="white"
                        (click)="beginPausedTimeEntryEdit(timeEntry)"
                      >
                        Bearbeiten
                      </button>
                    }
                  }
                </div>
                @if (editingTimeEntryId === timeEntry.id) {
                  <div class="grid grid-cols-1 md:grid-cols-4 gap-4 rounded-md border border-edge p-4">
                    <app-form-input-wrapper label="Start" [control]="timeEntryStartControl">
                      <input
                        type="time"
                        step="60"
                        appTailwindInput2
                        [control]="timeEntryStartControl"
                        [formControl]="timeEntryStartControl"
                        [attr.disabled]="savingTimeEntryId === timeEntry.id ? true : null"
                      />
                    </app-form-input-wrapper>
                    <app-form-input-wrapper label="Ende" [control]="timeEntryEndControl">
                      <input
                        type="time"
                        step="60"
                        appTailwindInput2
                        [control]="timeEntryEndControl"
                        [formControl]="timeEntryEndControl"
                        [attr.disabled]="savingTimeEntryId === timeEntry.id ? true : null"
                      />
                    </app-form-input-wrapper>
                    <div class="flex items-end gap-2 md:col-span-2">
                      <button
                        type="button"
                        appTailwindButton
                        (click)="savePausedTimeEntry(timeEntry)"
                        [disabled]="savingTimeEntryId === timeEntry.id"
                      >
                        Speichern
                      </button>
                      <button
                        type="button"
                        appTailwindButton
                        color="white"
                        (click)="cancelTimeEntryEdit.emit()"
                        [disabled]="savingTimeEntryId === timeEntry.id"
                      >
                        Abbrechen
                      </button>
                    </div>
                    @if (timeEntryError) {
                      <p class="text-sm text-red-600 md:col-span-4" role="alert">
                        {{ timeEntryError }}
                      </p>
                    }
                  </div>
                }
              }
            </div>
          }

          @if (
            timer.state === 'active' &&
            timer.workItemState === 'embedded' &&
            timer.isToday &&
            timer.startTime
          ) {
            <div class="space-y-3 pt-6 px-4 sm:px-6">
              <label class="block text-sm/6 font-medium text-fg-primary">Aktiver Zeiteintrag</label>
              @if (editingTimeEntryId === '__running') {
                <div class="grid grid-cols-1 md:grid-cols-4 gap-4 rounded-md border border-edge p-4">
                  <app-form-input-wrapper label="Start" [control]="timeEntryStartControl">
                    <input
                      type="time"
                      step="60"
                      appTailwindInput2
                      [control]="timeEntryStartControl"
                      [formControl]="timeEntryStartControl"
                      [attr.disabled]="savingTimeEntryId === '__running' ? true : null"
                    />
                  </app-form-input-wrapper>
                  <div class="flex flex-col justify-end pb-1">
                    <span class="text-sm text-fg-secondary">Ende</span>
                    <span class="tabular-nums text-fg-primary">Jetzt</span>
                  </div>
                  <div class="flex items-end gap-2 md:col-span-2">
                    <button
                      type="button"
                      appTailwindButton
                      (click)="saveActiveStartTime()"
                      [disabled]="savingTimeEntryId === '__running'"
                    >
                      Speichern
                    </button>
                    <button
                      type="button"
                      appTailwindButton
                      color="white"
                      (click)="cancelTimeEntryEdit.emit()"
                      [disabled]="savingTimeEntryId === '__running'"
                    >
                      Abbrechen
                    </button>
                  </div>
                  @if (timeEntryError) {
                    <p class="text-sm text-red-600 md:col-span-4" role="alert">
                      {{ timeEntryError }}
                    </p>
                  }
                </div>
              } @else {
                <button
                  type="button"
                  appTailwindButton
                  color="white"
                  (click)="beginActiveStartTimeEdit()"
                >
                  Startzeit korrigieren
                </button>
              }
            </div>
          }
        </div>
      </form>
    }

    <div
      class="px-4 sm:px-6 py-4 flex w-full justify-end gap-4 rounded-md border-t border-edge bg-surface leading-10"
    >
      <button
        type="button"
        appTailwindButton
        (click)="saveWork.emit()"
        [disabled]="timer.state === 'active' || !workForm || editingTimeEntryId !== null || savingTimeEntryId !== null"
      >
        Timerwerte als Arbeit speichern
      </button>
    </div>
  </div>
</div>
